var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#2A8981"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6832 13.5088H14.2797C13.8534 13.5088 13.5078 13.8544 13.5078 14.2807V19.6842C13.5078 20.1105 13.8534 20.4562 14.2797 20.4562H19.6832C20.1096 20.4562 20.4552 20.1105 20.4552 19.6842V14.2807C20.4552 13.8544 20.1096 13.5088 19.6832 13.5088Z",
    fill: "#6554BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6832 13.5088H14.2797C13.8534 13.5088 13.5078 13.8544 13.5078 14.2807V19.6842C13.5078 20.1105 13.8534 20.4562 14.2797 20.4562H19.6832C20.1096 20.4562 20.4552 20.1105 20.4552 19.6842V14.2807C20.4552 13.8544 20.1096 13.5088 19.6832 13.5088Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7184 13.5088H24.3149C23.8886 13.5088 23.543 13.8544 23.543 14.2807V19.6842C23.543 20.1105 23.8886 20.4562 24.3149 20.4562H29.7184C30.1447 20.4562 30.4903 20.1105 30.4903 19.6842V14.2807C30.4903 13.8544 30.1447 13.5088 29.7184 13.5088Z",
    fill: "#6554BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7184 13.5088H24.3149C23.8886 13.5088 23.543 13.8544 23.543 14.2807V19.6842C23.543 20.1105 23.8886 20.4562 24.3149 20.4562H29.7184C30.1447 20.4562 30.4903 20.1105 30.4903 19.6842V14.2807C30.4903 13.8544 30.1447 13.5088 29.7184 13.5088Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6832 23.5439H14.2797C13.8534 23.5439 13.5078 23.8895 13.5078 24.3159V29.7194C13.5078 30.1457 13.8534 30.4913 14.2797 30.4913H19.6832C20.1096 30.4913 20.4552 30.1457 20.4552 29.7194V24.3159C20.4552 23.8895 20.1096 23.5439 19.6832 23.5439Z",
    fill: "#6554BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6832 23.5439H14.2797C13.8534 23.5439 13.5078 23.8895 13.5078 24.3159V29.7194C13.5078 30.1457 13.8534 30.4913 14.2797 30.4913H19.6832C20.1096 30.4913 20.4552 30.1457 20.4552 29.7194V24.3159C20.4552 23.8895 20.1096 23.5439 19.6832 23.5439Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7184 23.5439H24.3149C23.8886 23.5439 23.543 23.8895 23.543 24.3159V29.7194C23.543 30.1457 23.8886 30.4913 24.3149 30.4913H29.7184C30.1447 30.4913 30.4903 30.1457 30.4903 29.7194V24.3159C30.4903 23.8895 30.1447 23.5439 29.7184 23.5439Z",
    fill: "#6554BE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7184 23.5439H24.3149C23.8886 23.5439 23.543 23.8895 23.543 24.3159V29.7194C23.543 30.1457 23.8886 30.4913 24.3149 30.4913H29.7184C30.1447 30.4913 30.4903 30.1457 30.4903 29.7194V24.3159C30.4903 23.8895 30.1447 23.5439 29.7184 23.5439Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.4ae9dc173784776fb88cb0b898bcec9d.svg";
export { ForwardRef as ReactComponent };